var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsContainerOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.51,74.75h-4V70.16h4Zm0-8.85h-4V61.31h4Zm0-8.85h-4V52.46h4Zm0-8.85h-4V43.61h4Zm0-8.85h-4V34.76h4Zm0-8.85h-4V25.91h4ZM63.3,74.75h-4V70.16h4Zm0-8.85h-4V61.31h4Zm0-8.85h-4V52.46h4Zm0-8.85h-4V43.61h4Zm0-8.85h-4V34.76h4Zm0-8.85h-4V25.91h4ZM14,14V81.5A4.49,4.49,0,0,0,18.5,86h63A4.49,4.49,0,0,0,86,81.5V14ZM81.5,81.5H63.3V79h-4V81.5H40.51V79h-4V81.5h-18V18.34h18v3.31h4V18.34H59.3v3.31h4V18.34H81.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsContainerOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Container_Outline_Black_RGB.15e534870faac35393ff519d1e02d2db.svg";
export { ForwardRef as ReactComponent };